"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var React = tslib_1.__importStar(require("react"));
var houston_styles_1 = tslib_1.__importStar(require("@eduzz/houston-styles"));
var Divider = function (_a) {
    var className = _a.className, vertical = _a.vertical, rest = tslib_1.__rest(_a, ["className", "vertical"]);
    var ref = React.useRef(null);
    React.useEffect(function () {
        var _a;
        if (ref.current && vertical) {
            ref.current.style.height = "".concat((_a = ref.current.parentElement) === null || _a === void 0 ? void 0 : _a.clientHeight, "px");
        }
    }, [vertical]);
    return (0, jsx_runtime_1.jsx)("hr", tslib_1.__assign({ ref: ref, className: (0, houston_styles_1.cx)(className, { 'hst-divider-vertical': vertical }) }, rest));
};
/**
 * @deprecated Use Divider from Antd
 * https://ant.design/components/divider/
 */
exports.default = React.memo((0, houston_styles_1.default)(Divider, { label: 'hst-divider' })(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return (0, houston_styles_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    border-style: solid;\n    opacity: ", ";\n    border-color: ", ";\n    border-width: 0 0 ", ";\n    width: 100%;\n\n    &.hst-divider-vertical {\n      width: auto;\n      border-width: 0 0 0 ", ";\n      display: inline-flex;\n    }\n  "], ["\n    border-style: solid;\n    opacity: ", ";\n    border-color: ", ";\n    border-width: 0 0 ", ";\n    width: 100%;\n\n    &.hst-divider-vertical {\n      width: auto;\n      border-width: 0 0 0 ", ";\n      display: inline-flex;\n    }\n  "])), theme.opacity.level[3], theme.neutralColor.low.pure, theme.border.width.xs, theme.border.width.xs);
}));
var templateObject_1, templateObject_2;
